import { useEffect } from 'react';

/**
 * Cookie Consent Component
 * 
 * Wraps the vanilla JS cookie consent implementation from static site scripts.
 * This ensures consistent behavior between static site and React app.
 * 
 * The component doesn't render anything - the vanilla JS script handles
 * all DOM manipulation and UI rendering.
 */
const CookieConsent = () => {
  useEffect(() => {
    // Dynamically import and initialize cookie consent script
    // Script is replicated to src/assets/scripts/ during replication
    const initCookieConsent = async () => {
      try {
        // Import the cookie consent script from replicated location
        // The script is an ES module, so we can import it directly
        const cookieConsentModule = await import('../../../assets/scripts/cookie-consent.js');
        
        if (cookieConsentModule && cookieConsentModule.initCookieConsent) {
          await cookieConsentModule.initCookieConsent();
        } else {
          console.debug('Cookie consent module loaded but initCookieConsent not found');
        }
      } catch (error) {
        // Silently handle errors (script may not be available, ad blockers, etc.)
        // This is expected if the script hasn't been replicated yet
        console.debug('Cookie consent not initialized:', error);
      }
    };

    // Initialize cookie consent after component mounts
    // Small delay to ensure page is ready
    const timer = setTimeout(() => {
      initCookieConsent();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Component doesn't render anything - script handles UI
  return null;
};

export default CookieConsent;

